var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    bg-[#163982]\n    text-lg\n    p-2\n    w-full\n    text-left\n    pl-6\n    font-bold\n    text-white\n  "},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }